/**
 * The glyphs New campaign and Contact lists draw (design export 2026-10-09), named once.
 *
 * `shell/glyph.ts` is the only module that may import `@phosphor-icons/react` (console.test.ts), and it
 * belongs to the shell. Seven of the prototype's icons were added to it at integration (2026-10-09) — `ph-info`, `ph-play-circle`,
 * `ph-flag-checkered`, `ph-arrow-bend-up-left`, `ph-list-numbers`, `ph-clock` and `ph-shapes` — so until
 * the shell adds them (`Info`, `PlayCircle`, `FlagCheckered`, `ArrowBendUpLeft`, `ListNumbers`, `Clock`,
 * `Shapes`) these entries point at the nearest glyph it has. Swapping one is a one-line change here.
 */
import { GLYPH } from "../../shell/glyph.js";

export const CAMPAIGN_GLYPH = {
  /** Prototype: ph-info. */
  info: GLYPH.info,
  /** Prototype: ph-play-circle. */
  playCircle: GLYPH.playCircle,
  /** Prototype: ph-flag-checkered. */
  finishLine: GLYPH.finishLine,
  /** Prototype: ph-arrow-bend-up-left. */
  arrowBendUpLeft: GLYPH.arrowBendUpLeft,
  /** Prototype: ph-list-numbers. */
  listNumbers: GLYPH.numberedSteps,
  /** Prototype: ph-clock. */
  clock: GLYPH.clock,
  /** Prototype: ph-shapes. */
  shapes: GLYPH.shapes,
  addressBook: GLYPH.addressBook,
  arrowRight: GLYPH.arrowRight,
  calendarBlank: GLYPH.calendarBlank,
  caretDown: GLYPH.caretDown,
  check: GLYPH.check,
  minus: GLYPH.minus,
  checkCircle: GLYPH.checkCircle,
  warningCircle: GLYPH.warningCircle,
  phoneOutgoing: GLYPH.phoneOutgoing,
} as const;
